//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services

//components
import custContainer from "emun.cust/cust-container";
import custDetails from "emun.cust/details/cust-details";

//directives
// import custList from "emun.cust/cust-list";

//states
import custStates from "emun.cust/cust.states";

//styles
import "emun.cust/cust.styles";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

export const services = {};

export const components = {
  custContainer,
  custDetails,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states: custStates(),
};
